import React, { useContext } from "react";
import RichText from "myplan/components/RichText";

import { FurnitureContext } from "myplan/utils/furniture";
import { Container, Header, Scroll } from "./styles";
import { AppTheme } from "../../utils/theme";
import { useTheme } from "@emotion/react";

const SafeMode = () => {
    const furniture = useContext(FurnitureContext);

    const {
        backgroundImage: { logo: Logo },
    }: AppTheme = useTheme() as AppTheme;

    return (
        <Container>
            <Scroll>
                <Header>
                    <Logo
                        width={170}
                        height={50}
                        style={{ marginVertical: 30 }}
                    />
                </Header>
                <RichText doc={furniture.safeMode} />
            </Scroll>
        </Container>
    );
};

export default SafeMode;
